import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { CustomerReportResponse, ReportRequestData } from "../../../../graphql/types"

export const fetchCustomersReportData = (
    headers: Record<string, any>,
    data: ReportRequestData
): Promise<Maybe<CustomerReportResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query customersReport($data: ReportRequestData!) {
                  customersReport(data: $data) {
                    data {
                        id
                        customerName
                        companyName
                        phoneNumber
                        position
                        customerPersonalName
                        email
                        gender
                        isCompany
                        last28daysSpend
                        lastVisitDatetime
                        lastVisitSpend
                        lastTransactionSpend
                        numberOfVisits
                        totalSpend
                        averageSpend
                        valuation
                        mostFrequent                    
                    }
                    totalCount
                  }
                }
                
            `,
            operationName: "customersReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.customersReport) {
            return response.data.customersReport
        }

        return null
    })
